<template>
  <vx-card title="新建客户">
    <vx-form class="w-full" layout="v" label-align="top" v-slot="{invalid, handleSubmit}">
      <form-item help="客户的基本信息便于您整理和联系，必要时可以让客户登录修改商品和溯源信息，以下信息我们会严格为您保密">
        <b>客户基本信息</b>
      </form-item>
<!--      <form-item required label="邮箱" rules="email">-->
<!--        <vs-input class="w-full" placeholder="请输入邮箱" v-model="user.email" @input="handleEmail"/>-->
<!--      </form-item>-->
      <form-item label="用户名" rules="required" :msgs="{required: '用户名必填'}">
        <vx-input-group class="md:w-1/2">
          <vs-input class="w-auto" data-vv-name="username" placeholder="请输入用户名" v-model="user.userName"/>
          <span class="block" slot="append">@qds{{$s.auth.user.uid}}</span>
        </vx-input-group>
      </form-item>
      <form-item label="称呼">
        <vs-input class="w-full" placeholder="请输入昵称" v-model="user.nickName"/>
      </form-item>
<!--      <form-item label="手机号">-->
<!--        <vs-input class="w-full" placeholder="请输入手机号" v-model="user.phone"/>-->
<!--      </form-item>-->
      <form-item label="是否允许登录" label-align="none">
        <vs-switch v-model="user.enabledLogin"></vs-switch>
      </form-item>
      <form-item :required="isNew" label="登录密码" help="如果不修改密码请留空，如果需要重置密码，请输入密码，支持数字、字母" v-if="user.enabledLogin">
        <vs-input class="w-full" placeholder="请输入密码" v-model="user.password" />
        <vs-button size="small" type="border" class="mt-1" @click="genRandomPassword">生成随机密码</vs-button>
      </form-item>


      <form-item help="客户的企业信息用于显示在溯源页面" class="mt-10">
        <b>客户企业信息</b>
      </form-item>

      <!-- 客户企业信息 -->
      <form-item label="客户企业名称" rules="required" help="客户企业名全称">
        <vs-input class="w-full" placeholder="请输入企业名称" v-model="company.name"/>
      </form-item>
      <form-item label="行业类型" help="行业类型，公开后显示在溯源页面，如果不在列表内可输入">
        <vs-input class="w-full" placeholder="请输入行业类型" v-model="company.industry"/>
      </form-item>
      <form-item label="企业官网" help="公开后显示在溯源页面上，并直接跳转">
        <vs-input class="w-full" placeholder="请输入网址" v-model="company.introSite"/>
      </form-item>
      <form-item label="网上店铺" help="公开后显示在溯源页面上，并直接跳转">
        <vs-input class="w-full" placeholder="请输入网址" v-model="company.shopSite"/>
      </form-item>
      <form-item label="实体店地址" help="填写您的店面地址信息">
        <vs-input class="w-full" placeholder="请输入详细地址" v-model="company.shopAddr"/>
      </form-item>
      <form-item required class="mt-5" label="企业Logo" help="公开后显示在溯源页面上">
        <upload
          fileName="file"
          v-model="company.logo"
          data-vv-name="installer"
          automatic
          text="上传Logo"
          accept=".jpg,.png"
          action="/admin/v1/file/upload"
          :single-upload="true"
          :limit="1"
        />
      </form-item>
      <form-item class="mt-5" label="微信公众号" help="公开后显示在溯源页面上，使用户直接关注客户的微信公众号">
        <upload
          fileName="file"
          v-model="company.wxpubImg"
          data-vv-name="installer"
          automatic
          text="上传微信公众号二维码"
          accept=".jpg,.png"
          action="/admin/v1/file/upload"
          :single-upload="true"
          :limit="1"
        />
      </form-item>
      <form-item label="公司隐私设置" help="只有打勾的信息才会在溯源页面显示，未打勾的不会显示" label-align="none">
        <ul class="centerx">
          <li>
            <vs-checkbox v-model="company.publicFields" vs-value="name">企业名称</vs-checkbox>
          </li>
          <li>
            <vs-checkbox v-model="company.publicFields" vs-value="industry">行业类型</vs-checkbox>
          </li>
          <li>
            <vs-checkbox v-model="company.publicFields" vs-value="introSite">企业宣传网址</vs-checkbox>
          </li>
          <li>
            <vs-checkbox v-model="company.publicFields" vs-value="shopSite">网上店铺</vs-checkbox>
          </li>
          <li>
            <vs-checkbox v-model="company.publicFields" vs-value="shopAddr">实体店地址</vs-checkbox>
          </li>
          <li>
            <vs-checkbox v-model="company.publicFields" vs-value="logo">企业Logo</vs-checkbox>
          </li>
          <li>
            <vs-checkbox v-model="company.publicFields" vs-value="wxpubImg">微信公众号</vs-checkbox>
          </li>
        </ul>
      </form-item>

      <form-item>
        <vs-button class="mr-3 mb-2" :disabled="invalid" @click="handleSubmit(submitForm)">提交</vs-button>
        <vs-button color="warning" type="border" class="mb-2" to="/customer/list">返回</vs-button>
      </form-item>
    </vx-form>
  </vx-card>
</template>

<script>

  export default {
    name: "edit",
    data() {
      return {
        user: {
          enabledLogin: false,
          password: '',
        },
        company: {
          publicFields: [],
        },
      }
    },
    computed: {
      isNew() {
        return !this.$route.params.id
      }
    },
    async mounted() {

      if (!this.isNew) {
        const customer = await this.$s.user.detailCustomer(this.$route.params.id)
        this.user = {
          ...customer,
          password: '',
          enabledLogin: customer.status == 1,
        }
        this.company = {
          ...customer,
          publicFields: customer.publicFields || []
        }
      }
    },
    methods: {
      genRandomPassword() {
        this.user.password = Math.random().toString(36).substr(2)
      },
      // handleEmail(e) {
      //   const [username] = e.split('@')
      //   this.user.userName = username
      // },
      async submitForm() {
        const data = {
          user: {
            ...this.user,
            status: this.user.enabledLogin ? 1 : 3,
          },
          company: { ...this.company }
        }
        if (!this.isNew) {
          data.uid = Number(this.$route.params.id)
          await this.$s.user.updateCustomer(data)
        } else {
          data.user.userName = data.user.userName + '@qds' + this.$s.auth.user.uid
          await this.$s.user.createCustomer(data)
        }
        this.$notify({
          title: '客户资料更新成功',
        })
        this.$router.push('/customer/list')
      }
    }
  }
</script>

<style scoped>

</style>